import React from 'react';
import ContextViewFileList from './Contexts/ContextViewFileList';
import {Button, IconButton} from '@mui/material';
import {Home} from '@mui/icons-material';
import {restore_slashes} from './background_functions';

export const ViewFileListPath = () => {
  const {breadcrumbs, navigate_to_page_root, navigate_to_dir} = React.useContext(ContextViewFileList);

  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <p>
      <IconButton onClick={navigate_to_page_root}>
        <Home />
      </IconButton>
      /
      {breadcrumbs.map((el) => (
        <React.Fragment key={el.id}>
          <Button onClick={() => navigate_to_dir(el.id)}>{restore_slashes(el.name)}</Button>
          /
        </React.Fragment>
      ))}
    </p>
  );
};
